export default "__VITE_ASSET__DImUDZZX__"